import { render, staticRenderFns } from "./managerDashboard.vue?vue&type=template&id=2fd49c06&scoped=true"
import script from "./managerDashboard.vue?vue&type=script&lang=js"
export * from "./managerDashboard.vue?vue&type=script&lang=js"
import style0 from "./managerDashboard.vue?vue&type=style&index=0&id=2fd49c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd49c06",
  null
  
)

export default component.exports